import React from 'react';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import './Header.css'
import { Link } from 'react-router-dom';
import { Use_reduce_state } from './Store';
import Search from './Search';

function Header() {
    const {product:{cart}} = Use_reduce_state();
    const {product:{searchKey , dis}} = Use_reduce_state();
  return (
    <div>
        <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
            <Link className="navbar-brand" to="/">LetsShopp</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 ">
                    <li className="nav-item ">
                        <Link className="nav-link active" aria-current="page" to='/'>Home <span className='sr-only'></span></Link>
                    </li>
                </ul>
                
                <Search/>
                <Link to='/cart' > <i className='cart-icon' data={cart && cart.length} ><ShoppingCartIcon  /></i></Link>
                
            </div>
            </div>
        </nav>
    </div>
  )
}

export default Header